import { IAction } from "../model/IAction";
import { ElementType, IProcessData } from "../model/IProcessData";
import { Triggers } from "../model/ITriggerData";
const startElementId = "StartEvent_1";
const EMPTY_PROCESS_BPMN = `<?xml version="1.0" encoding="UTF-16"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="Process_1" isExecutable="false">
    <bpmn2:startEvent id="${startElementId}" name="Manual" />
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="${startElementId}">
        <dc:Bounds height="36.0" width="36.0" x="412.0" y="240.0"/>
      </bpmndi:BPMNShape>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn2:definitions>`;

export const NEW_PROCESS = "NEW_PROCESS";
export function newProcess(processInputData: IProcessInputData): NewProcessAction {
  const data: IProcessData = {
    bpmn: EMPTY_PROCESS_BPMN,
    elementParameters: [{ id: startElementId, type: ElementType.Start, selectedTypeId: Triggers.ManualTrigger.triggerType, parameters: {}, name: "Manual" }],
    name: "",
    description: "",
    id: 0,
    triggerData: [],
    tagString: "",
    majorVersion: 0,
    minorVersion: 1,
    version: 1,
    changeDescription: "",
    isSubprocess: processInputData.isSubprocess,
    apiSpecId: null,
    processVariables: [],
  };
  return {
    type: NEW_PROCESS,
    processData: data,
  };
}

export interface IProcessInputData {
  isSubprocess: boolean;
}

export interface NewProcessAction extends IAction {
  processData: IProcessData;
}
